var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh !important"}},[_c('Header',{attrs:{"color":"trans"}}),_c('MainCarousel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }